import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'lm-smtp-settings',
    templateUrl: 'smtp-settings.component.html'
})
export class SmtpSettingsComponent {
    @Output() public saveData: EventEmitter<{host: string, port: number, secure: boolean, user: string, pass: string}> = new EventEmitter();
    @Output() public resetData: EventEmitter<any> = new EventEmitter();

    private host: string = '';
    private port: number = 465;
    private secure: boolean = true;
    private smtpusername: string = '';
    private smtppassword: string = '';

    private _smtpCredentials: any;
    @Input() set smtpCredentials(credentials: { host: string, port: number, secure: boolean, user: string, pass: string }) {
        if (credentials) {
            this.host = credentials.host;
            this.port = credentials.port;
            this.secure = credentials.secure;
            this.smtpusername = credentials.user;
            this.smtppassword = credentials.pass;
        } else {
            this.host = '';
            this.port = 465;
            this.secure = true;
            this.smtpusername = '';
            this.smtppassword = '';
        }
        this._smtpCredentials = credentials;
    }

    get smtpCredentials() {
        return this._smtpCredentials;
    }

    public didTapSendSMTPInformation() {
        this.saveData.next(
            {
                host: this.host,
                port: this.port,
                secure: this.secure,
                user: this.smtpusername,
                pass: this.smtppassword
            }
        );
    }

    public didTapResetSMTPInformation() {
        this.resetData.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/components/smtp-settings/smtp-settings.component.ts